import { Tag } from 'antd'
import { formatFeatureFlag } from '../types/tenant.types'

interface FeatureFlagTagProps {
  flag: string
}

export function FeatureFlagTag({ flag }: FeatureFlagTagProps) {
  return (
    <Tag color="blue">
      {formatFeatureFlag(flag)}
    </Tag>
  )
}
